import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { RiyalIcon } from '@/lib/currency';

export default function PaymentModeWidget({ paymentModeCards, fmtAmt }) {
  return (
    <div>
      <h2 className="text-lg sm:text-2xl font-bold font-outfit mb-4">Payment Mode Breakdown</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {paymentModeCards.map((card) => {
          const Icon = card.icon;
          return (
            <Card key={card.title} className="stat-card border-border" data-testid={card.testId}>
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium text-muted-foreground">{card.title}</CardTitle>
                <div className={`${card.bgColor} p-2 rounded-lg`}>
                  <Icon className={`h-5 w-5 ${card.color}`} strokeWidth={2} />
                </div>
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold font-outfit inline-flex items-center gap-1"><RiyalIcon size="0.7em" /> {fmtAmt(card.numValue)}</div>
                {card.subItems && card.subItems.length > 0 && (
                  <div className="mt-2 pt-2 border-t border-border flex flex-wrap gap-x-3 gap-y-1">
                    {card.subItems.map((sub, idx) => (
                      <span key={idx} className={`text-[10px] ${sub.color} font-medium`}>
                        {sub.label}: <RiyalIcon size="0.85em" /> {sub.value < 0 ? '-' : ''}{Math.abs(sub.value || 0).toLocaleString()}
                      </span>
                    ))}
                  </div>
                )}
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
